export default __webpack_public_path__ + "static/media/fantxt-com.ab3d7269.svg";